import { render, staticRenderFns } from "./ReportL01.vue?vue&type=template&id=971a6fd8"
import script from "./ReportL01.vue?vue&type=script&lang=js"
export * from "./ReportL01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports